import type { FaireCollectionEntity } from "../../entity_types/collection";

export const pbc_t9qyp5t3k5: FaireCollectionEntity = {
  token: "pbc_t9qyp5t3k5",
  type: "collection",
  name: "JUST DROPPED: FALL FAVES",
  heroImageUrl:
    "https://cdn.faire.com/fastly/4ab9dc7a6c676daef6e36f6cf70ea46fc6d335c5fae36b6537c0d5dffd4d20f9.jpeg",
  itemCount: 15,
  description:
    "Preorder all your fall faves now! Curated especially for your night life baddies ❤️‍🔥\nFor styling tips or an exclusive look at new styles, check out our socials IG: @_lemonadeshoes or TIKTOK: @lemonadeshoes",
  brandToken: "b_mz3xxxsvnf",
  productTokens: [],
  meta: {
    source: "api",
    importedAt: "2026-08-13T23:39:29.977Z",
    importedBy: "entity-db-import-collections",
  },
};
